module.exports = __webpack_public_path__ + "img/drh5_popwin2_img.75bb2faf.png";